import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import { Link, Redirect, withRouter } from 'react-router-dom';
import MenuButton from '../Menu/MenuButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import DeleteAlert from '../Alert/DeleteAlert.jsx';
import { FormattedMessage, injectIntl } from 'react-intl';
import { NotificationManager } from 'react-notifications';
import withUser from '../HOC/HOCwithUser.jsx';

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc'
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}

class AddressListHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const rows = [
            {
                id: 'name',
                label: this.props.formatMessage({
                    id: 'address.name'
                })
            },
            {
                id: 'email',
                label: this.props.formatMessage({
                    id: 'address.email'
                })
            },
            {
                id: 'address_line1',
                label: this.props.formatMessage({
                    id: 'address.address'
                })
            },
            {
                id: 'city',
                label: this.props.formatMessage({
                    id: 'address.city'
                })
            },
            {
                id: 'state',
                label: this.props.formatMessage({
                    id: 'address.state'
                })
            },
            {
                id: 'country',
                label: this.props.formatMessage({
                    id: 'address.country'
                })
            },
            {
                id: 'phone',
                label: this.props.formatMessage({
                    id: 'address.phone'
                })
            },
            {
                id: 'action',
                label: this.props.formatMessage({
                    id: 'address.action'
                })
            }
        ];

        const { order, orderBy } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {rows.map(
                        row => (
                            <TableCell
                                key={row.id}
                                align={row.numeric ? 'right' : 'left'}
                                padding={
                                    row.disablePadding ? 'none' : 'default'
                                }
                                sortDirection={
                                    orderBy === row.id ? order : false
                                }
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={
                                        row.numeric
                                            ? 'bottom-end'
                                            : 'bottom-start'
                                    }
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        ),
                        this
                    )}
                </TableRow>
            </TableHead>
        );
    }
}

AddressListHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85)
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark
            },
    spacer: {
        flex: '1 1 100%'
    },
    actions: {
        color: theme.palette.secondary.main
    },
    title: {
        flex: '0 0 auto'
    }
});

let AddressListToolbar = props => {
    const { numSelected, classes, deleteAction, match, taskDataNew, bookingdataNew, loginPathPropsNew, BookingPath, taskDataFromConfirmPage } = props;

    return (
        <div className="db-list-com d-flex">
            <div className={classes.spacer} />
            <div className={classes.actions}>
                {numSelected > 0 ? (
                    <Tooltip title="Delete">
                        <IconButton
                            aria-label="Delete"
                            onClick={this.deleteAddress}
                        >
                            <DeleteIcon onClick={deleteAction} />
                        </IconButton>
                    </Tooltip>
                ) : (
                    <Tooltip title="Add">
                        <Button variant="fab" color="primary" aria-label="Add">
                            <Link
                                to={{
                                    pathname: '/user/address/create',

                                    state: {
                                        taskData: taskDataNew,
                                        booking_data: bookingdataNew,
                                        loginPath: loginPathPropsNew,
                                        BookingPath: BookingPath,
                                        taskDataFromConfirmPage: taskDataFromConfirmPage
                                    }
                                }}
                                style={{
                                    textDecoration: 'none',
                                    color: '#FFFFFF',
                                    fontSize: '25px'
                                }}
                            >
                                <AddIcon />
                            </Link>
                        </Button>
                    </Tooltip>

                )}
            </div>
        </div>
    );
};

AddressListToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired
};

AddressListToolbar = withStyles(toolbarStyles)(AddressListToolbar);

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    },
    tableWrapper: {
        overflowX: 'auto'
    }
});

class AddressList extends React.Component {
    constructor(props) {
        console.log("newdataaaaaaa", props)
        console.log("role", props.userData.role)


        super();
        this.state = {
            order: 'asc',
            orderBy: 'created_at',
            selected: [],
            data: props.userData.addresses,
            page: 0,
            rowsPerPage: 5,
            clickValue: '',
            item: '',
            itemId: '',
            showAlert: false,
            defaultAddressvalue: '',
            deleteAlert: false,
            selectedDeleteKey: '',
            taskDataNew: (props.userData.role == 420 && props.location.state !== undefined) ? props.location.state.taskData : '',
            booking_dataNew: (props.userData.role == 420 && props.location.state !== undefined) ? props.location.state.booking_data : '',
            loginPathProps: (props.userData.role == 420 && props.location.state !== undefined) ? props.location.state.loginPath : '',
            taskDataFromConfirmPage: (props.userData.role == 420 && props.location.state !== undefined) ? props.location.state.taskDataFromConfirmPage : '',
            BookingPath: (props.userData.role == 420 && (props.history.location.state !== undefined && props.history.location.state.BookingPath !== undefined)) ? props.history.location.state.BookingPath : '',
            taskDataFromConfirmPage: (props.userData.role == 420 && (props.history.location.state !== undefined && props.history.location.state.taskDataFromConfirmPage !== undefined)) ? props.history.location.state.taskDataFromConfirmPage : '',
            customerRole: props.userData.role
        };
    }



    actionCallbacks(action, res) {
        if (action === 'update') {
            this.setState({
                clickValue: 'update',
                item: res,
                menuState: false,
                itemId: res.key
            });
        }
        if (action === 'delete') {
            this.setState(
                {
                    selectedDeleteKey: res.key,
                    menuState: false
                },
                () => {
                    this.deleteRecord();
                }
            );
        }
    }
    componentDidMount() {
        this.getData();
    }
    getData() {
        this.props.getAddressListAction(this.onDone);
    }
    onDone = (success, data) => {
        if (success) {
            this.setState({ data: data.detail.addresses });
        }
    };
    componentDidUpdate(prevProps, prevState) {
        if (prevState.data.length !== this.state.data.length) {
            this.setState({ data: this.state.data });
        }
    }
    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }
        this.setState({ order, orderBy });
    };

    handleSelectAllClick = event => {
        if (event.target.checked) {
            this.setState(state => ({ selected: state.data.map(n => n.key) }));
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    isSelected = id => this.state.selected.indexOf(id) !== -1;
    deleteRecord = () => {
        this.setState({ showAlert: true });
    };
    deleteAddress = () => {
        const { selectedDeleteKey } = this.state;
        this.props.deleteAddressAction(
            {
                id: selectedDeleteKey
            },
            (success, data) => this.onDeleteDone(success, data)
        );
    };
    onDeleteDone = (success, data) => {
        this.setState({ loader: false });
        if (success) {
            this.setState({ showAlert: false });
            NotificationManager.success(data.message, 'Success');
        }
    };
    renderDefaultAddress = () => {
        const defaultAddressvalue = this.state.data.filter(
            address => address.is_default == 1
        )[0];
        if (defaultAddressvalue) {
            return (
                <div className="ds-boar-title db-list-com">
                    <h2>
                        {' '}
                        <FormattedMessage
                            id="defaultAddress"
                            defaultMessage="Default Address"
                        />
                    </h2>
                    <p>{defaultAddressvalue.name},</p>
                    <p>
                        {defaultAddressvalue.phone},<br />
                        {defaultAddressvalue.email},<br />
                        {defaultAddressvalue.address_line1},
                        {defaultAddressvalue.city}, {defaultAddressvalue.state},{' '}
                        {defaultAddressvalue.country}
                    </p>
                </div>
            );
        }
    };

    render() {
        const { classes, match } = this.props;
        const { formatMessage } = this.props.intl;
        const {
            data,
            order,
            orderBy,
            selected,
            rowsPerPage,
            page,
            taskDataNew,
            booking_dataNew,
            loginPathProps,
            BookingPath,
            taskDataFromConfirmPage
        } = this.state;

        console.log("addressListdata", data)
        console.log("statteeeee", this.state)
        if (
            data.length > 0 &&
            this.props.history.location.state &&
            this.props.history.location.state.loginPath === "BookingConfirmAdressSignIn"
        ) {
            console.log("aaaaaaaaaaaaa", this.props.history.location.taskData);

            this.props.history.push({
                pathname: `/user/booking_confirm`,
                state: {
                    taskData: this.state.taskDataNew,
                    booking_data: this.state.booking_dataNew,
                    loginPath: this.state.loginPathProps,
                    taskDataFromConfirmPage: this.state.taskDataFromConfirmPage,
                    BookingPath: this.props.history.location.state.BookingPath
                }
            });
        }
        const emptyRows =
            rowsPerPage -
            Math.min(rowsPerPage, data.length - page * rowsPerPage);

        if (this.state.clickValue) {
            this.props.history.push({
                pathname: `/user/address/update/${this.state.itemId}`,
                state: { item: this.state.item }
            });
        }
        return (
            <div>
                <div className={classes.title + ' ds-boar-title'}>
                    <h2>
                        {' '}
                        <FormattedMessage
                            id="customer.addresses"
                            defaultMessage="Addressesaaaaaaaaaaaaaa"
                        />
                    </h2>
                </div>

                {/* {this.renderDefaultAddress()} */}
                <Paper className={classes.root}>
                    {
                        data.length > 0
                            ? null
                            :
                            <AddressListToolbar
                                numSelected={selected.length}
                                deleteAction={this.deleteRecord}
                                match={match}
                                taskDataNew={taskDataNew}
                                bookingdataNew={booking_dataNew}
                                loginPathPropsNew={loginPathProps}
                                BookingPath={BookingPath}
                                taskDataFromConfirmPage={taskDataFromConfirmPage}
                            />
                    }

                    <div
                        className={
                            classes.tableWrapper + ' db-list-com tz-db-table'
                        }
                    >
                        <Table
                            className={classes.table + ' bordered'}
                            aria-labelledby="tableTitle"
                        >
                            <AddressListHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={this.handleSelectAllClick}
                                onRequestSort={this.handleRequestSort}
                                rowCount={data.length}
                                formatMessage={this.props.intl.formatMessage}
                            />
                            <TableBody>
                                {stableSort(data, getSorting(order, orderBy))
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    .map(n => {
                                        const isSelected = this.isSelected(
                                            n.key
                                        );
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                aria-checked={isSelected}
                                                tabIndex={-1}
                                                key={n.key}
                                                selected={isSelected}
                                            >
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {n.name}
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {n.email}
                                                </TableCell>
                                                <TableCell>
                                                    {n.address_line1}
                                                </TableCell>
                                                <TableCell>{n.city}</TableCell>
                                                <TableCell>{n.state}</TableCell>
                                                <TableCell>
                                                    {n.country}
                                                </TableCell>
                                                <TableCell>{n.phone}</TableCell>
                                                <TableCell>
                                                    <MenuButton
                                                        rowData={n}
                                                        items={
                                                            data.length > 1
                                                                ? [
                                                                    {
                                                                        action:
                                                                            'update',
                                                                        label: formatMessage(
                                                                            {
                                                                                id:
                                                                                    'update'
                                                                            }
                                                                        )
                                                                    },
                                                                    {
                                                                        action:
                                                                            'delete',
                                                                        label: formatMessage(
                                                                            {
                                                                                id:
                                                                                    'delete'
                                                                            }
                                                                        )
                                                                    }
                                                                ]
                                                                : [
                                                                    {
                                                                        action:
                                                                            'update',
                                                                        label: formatMessage(
                                                                            {
                                                                                id:
                                                                                    'update'
                                                                            }
                                                                        )
                                                                    }
                                                                ]
                                                        }
                                                        menuId={'userMenu'}
                                                        menuCallback={(
                                                            action,
                                                            rowData
                                                        ) =>
                                                            this.actionCallbacks(
                                                                action,
                                                                rowData
                                                            )
                                                        }
                                                        iconType={MoreVertIcon}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                {emptyRows > 0 && (
                                    <TableRow
                                        style={{ height: 49 * emptyRows }}
                                    >
                                        <TableCell colSpan={8} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </div>
                </Paper>
                <DeleteAlert
                    open={this.state.showAlert}
                    title="address"
                    close={() => this.setState({ showAlert: false })}
                    handleYes={this.deleteAddress}
                    handleNo={() => this.setState({ showAlert: false })}
                />
            </div>
        );
    }
}

AddressList.propTypes = {
    classes: PropTypes.object.isRequired
};

const composedComponent = compose(
    withStyles(styles),
    connect(
        null,
        actions
    )
);

export default composedComponent(injectIntl(withRouter(withUser(AddressList))));



// WEBPACK FOOTER //
// ./src/components/Customer/AddressList.jsx